require("!!/home/jenkins/workspace/graylog-project-release/.dependencies/graylog2-server/graylog2-web-interface/node_modules/script-loader/addScript.js")(require("!!/home/jenkins/workspace/graylog-project-release/.dependencies/graylog2-server/graylog2-web-interface/node_modules/raw-loader/index.js!/home/jenkins/workspace/graylog-project-release/.dependencies/graylog2-server/graylog2-web-interface/public/javascripts/jquery-2.1.1.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./public/javascripts/jquery-2.1.1.min.js
// module id = 84
// module chunks = 0